module.exports = __webpack_public_path__ + "static/images/mb-2.009e79e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flat/mobile/mb-2.png
// module id = 352
// module chunks = 1